import store from '../store'

export default function influencer (to, from, next) {
  if (store.state.user.profile.type !== 'influencer') {
    return next({
      name: 'home'
    })
  }

  return false
}
